// CSS
// require('../scss/index.scss');
import '../scss/index.scss'

// import '@fortawesome/fontawesome-free/scss/fontawesome.scss'

// JavaScript
// window.$ = require('jquery');
require('./main.js');
require('./lazyload.js');
require('./alert.js');


